import { keepPreviousData, queryOptions, useQuery } from '@tanstack/react-query';

import { reportsApi } from '../api/reports-api';
import type { DayRange } from '../schemas/report-range';

import { reportKeys } from './report-keys';

export function overviewReportQueryOptions(storeId: string, { from, to }: DayRange) {
  return queryOptions({
    queryKey: reportKeys.overview(storeId, { from, to }),
    queryFn: () => reportsApi.overview(storeId, { from, to }),
    placeholderData: keepPreviousData,
  });
}

export function useOverviewReport(storeId: string, range: DayRange) {
  return useQuery(overviewReportQueryOptions(storeId, range));
}
